export default __webpack_public_path__ + "static/210512_更新完成_tc-17f4262dc55b67af37a07b6175705dc1.png";